import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import Button from '../button'
import { translate } from '../../helpers/stringHelpers'
import { formatCurrency } from '../../helpers/currencyHelpers'
import ConfigContext from '../../contexts/configContext'

const AutoBidButton = ({ currencyCode, isPrimary, currentValue, ...props }) => {
  const { locale } = useContext(ConfigContext)
  return (
    <Button
      className='lot__action lot__action--auto-bid'
      color={isPrimary ? 'primary' : 'link'}
      {...props}
    >
      {currentValue
        ? (<span>{translate('JspPublicCodes_JSP_LISTING_AUTOBID_CTA_EXISTING').replace('{0}', formatCurrency(locale, currencyCode, currentValue))}</span>)
        : translate('JspPublicCodes_JSP_SALE_PLACE_AUTOBID')}
    </Button>
  )
}

AutoBidButton.propTypes = {
  currencyCode: PropTypes.string.isRequired,
  isPrimary: PropTypes.bool.isRequired,
  currentValue: PropTypes.number
}

export default React.memo(AutoBidButton)
